import React from 'react';
import Header from '../components/Header';
import HomeContent from '../components/HomeContent';
import Footer from '../components/Footer';

export default function Home() {
  return (
    <div class='container mt-2'>
      <Header />
      <HomeContent />
      <Footer />
    </div>
  );
}
